import React from "react";
import { Options } from "@contentful/rich-text-react-renderer";
import { INLINES, Document } from "@contentful/rich-text-types";
import { parseIncludesForItem } from "@tiicker/util/lib/contentful/helpers";
import {
  ContentfulContentType,
  PublicationImageDocument,
  VideoSectionDocument,
} from "@tiicker/util/lib/contentful/types";
import { ContentfulLinkedAsset } from "components/Contentful/ContentfulLinkedComponent";
import Image from "components/Contentful/Image";
import { RichText } from "components/Contentful/RichText";
import MainParagraphText from "components/Paragraph/MainParagraphText";
import styles from "./ArticleRichText.module.scss";
import { Asset } from "contentful";
import VideoPlayer from "components/VideoPlayer/VideoPlayer";

interface Props {
  contentIncludes: any;
  richText: Document;
  unlink?: boolean;
}

const ArticleRichText = (props: Props) => {
  const overrideOptions: Options = {
    renderNode: {
      [INLINES.EMBEDDED_ENTRY]: (x) => {
        const targetType = x.data?.target?.sys?.contentType?.sys?.id;

        switch (targetType) {
          case ContentfulContentType.PublicationImage:
            const id = x.data.target.sys.id;

            const entry = parseIncludesForItem<PublicationImageDocument>(
              props.contentIncludes,
              id
            );

            if (!entry) {
              console.error(
                `Unable to find inline Publication Image with id: ${id}`
              );
              return <></>;
            }

            return (
              <>
                <ContentfulLinkedAsset
                  component={Image}
                  className="bodyImage"
                  assetId={entry.fields.image.sys.id}
                  includesList={props.contentIncludes}
                />
                <br />
              </>
            );

          case ContentfulContentType.VideoSection:
            const videoId = x.data.target.sys.id;

            const videoEntry = parseIncludesForItem<VideoSectionDocument>(
              props.contentIncludes,
              videoId
            );

            if (!videoEntry) {
              console.error(
                `Unable to find inline Video Section with id: ${videoId}`
              );
              return <></>;
            }

            const thumbnailEntry = parseIncludesForItem<Asset>(
              props.contentIncludes,
              videoEntry.fields.imageThumbnail.sys.id
            ) as unknown as Asset | null;

            if (!thumbnailEntry) {
              console.error(
                `Unable to find thumbnail for Video Section with video id: ${videoId}`
              );
              return <></>;
            }

            return (
              <>
                <VideoPlayer
                  thumbnailUrl={thumbnailEntry.fields.file.url}
                  video={videoEntry.fields.videoUpload}
                  videoUrl={videoEntry.fields.videoUrl}
                  inline={videoEntry.fields.isInline}
                />
                <br />
              </>
            );

          default:
            return <p>{targetType} not implemented</p>;
        }
      },
    },
  };

  return (
    <MainParagraphText className={styles.ArticleRichText}>
      <RichText
        document={props.richText}
        overrideOptions={overrideOptions}
        unlink={props.unlink}
      />
    </MainParagraphText>
  );
};

export default ArticleRichText;
